{
  "browserNotSupported": {
    "title": "Impossibile caricare il modulo",
    "text": "Per accedere al browser dei componenti utilizzare un browser aggiornato."
  },
  "main": {
    "more": "Altri accessori",
    "findMore": "Puoi trovare accessori per il retrofit/la conversione e l'aggiornamento del tuo veicolo qui nella nostra vasta gamma. Gli accessori che hai selezionato verranno inviati al tuo partner {{brand}} insieme alla richiesta del veicolo.",
    "topOffers": "Offerte TOP",
    "article": "<0>{{min}} - {{max}} / </0>{{productCount}} Prodotti",
    "noArticleFound": "0 Prodotti",
    "oemHint": "Scegliete subito gli accessori adatti alla vostra {{brand}}!",
    "noBrand": "Scegliete subito gli accessori adatti al vostro veicolo!",
    "outOfOrder": "Purtroppo al momento non ci sono prodotti disponibili.<0/>Stiamo aggiornando il nostro catalogo.<0/>Vi invitiamo a tornare a trovarci in un secondo momento.",
    "nextSlide": "Successivo",
    "prevSlide": "Precedente"
  },
  "cart": {
    "add": "Prodotto aggiunto al veicolo",
    "fullPrice": "Prezzo veicolo e accessori",
    "priceWithoutCar": "Prezzo accessori"
  },
  "navigation": {
    "zoom": "Zoom",
    "toggleSearch": "Attiva/disattiva ricerca",
    "cart": "Carrello",
    "cartDelete": "Rimuovi articolo dal carrello",
    "vehicle": "Veicolo selezionato",
    "maxBookmarksReached": "Massimo 15 prodotti raggiunti",
    "filter": {
      "toggleFilter": "Attiva/disattiva filtro",
      "topProducts": "Offerte TOP",
      "reset": "Ripristina filtro",
      "ready": "Fatto",
      "show": "Mostra risultati"
    },
    "searching": {
      "submit": "Invia",
      "close": "Chiudi",
      "placeholder": "Trova accessori corrispondenti ...",
      "suggestions": "Suggerimenti di ricerca",
      "categories": "Categorie",
      "products": "Prodotti",
      "productCount": "{{count}} prodotto",
      "productCount_other": "{{count}} prodotti",
      "showAll": "Mostra {{count}} risultato",
      "showAll_other": "Mostra tutti i {{count}} risultati",
      "expand": "Ricerca estesa",
      "show": "Mostra risultati",
      "found": {
        "withCategory": "Risultati della ricerca per \"{{fuzzy}}\" nella categoria \"{{category}}\"",
        "withOutCategory": "Risultati della ricerca per \"{{fuzzy}}\" da tutte le categorie"
      }
    },
    "share": "Condividi",
    "back": "Indietro",
    "details": "Dettagli",
    "add": "Aggiungi",
    "remove": "Rimuovi",
    "close": "Chiudi",
    "filtern": "Filtro",
    "closeFilter": "Chiudi filtro"
  },
  "productDetail": {
    "gallery": {
      "jumpToImageNumber": "Vai all'immagine {{number}}"
    },
    "articleNumber": "Numero di articolo",
    "relatedArticle": "Altri articoli che potrebbero interessarle:",
    "brand": "Marca",
    "priceBox": {
      "withVatAndMounting": "Prezzo comprensivo di IVA e montaggio",
      "withVat": "Prezzo comprensivo di IVA",
      "recommendedRetailPrice": "Prezzo consigliato non vincolante",
      "historicMinimalPurchasePrice": "Prezzo più basso negli ultimi 30 giorni",
      "priceDetails": "Dettagli sul prezzo",
      "priceDetailsHeadline": "Dettagli sul prezzo per questo articolo",
      "priceToday": "Prezzo per questo articolo oggi",
      "priceDetails30Days": "Prezzo più basso nei 30 giorni precedenti la variazione di prezzo",
      "close": "Chiudi",
      "addItem": "Aggiungere articolo",
      "removeItem": "Rimuovere articolo"
    },
    "infoBox": {
      "description": "Descrizione",
      "vehicles": "Adatto ai seguenti modelli",
      "empty": "Per questo prodotto non sono previste assegnazioni speciali per i veicoli.",
      "contacts": "Produttore"
    },
    "contacts": {
      "manufacturer-contact": "Informazioni di contatto del produttore",
      "responsible-contact": "Persona responsabile nell'UE",
      "trademark": "Marca"
    }
  },
  "productList": {
    "oemHint": "Accessori originali per il tuo {{brand}}!"
  }
}
